<template>
  <!-- eslint-disable -->
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <div class="flex-title">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <h1 class="contribuicao-text">{{nomeProjeto}} - Contribuições nos Testes</h1>
      <v-icon>mdi-bug</v-icon>
    </div>

    <v-divider class="mx-4" inset vertical></v-divider>

    <v-tabs v-model="tab" align-tabs="center" slider-color="#004984">
      <v-tab class="v-tab" :value="1"> Visão Detalhada </v-tab>
      <v-tab class="v-tab" :value="2"> Visão Resumida </v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item :value="1" class="my-10">
        <!-- Filtros -->
        <v-row>
          <v-col>
            <v-row align="center">
              <v-col cols="8">
                <p>
                  Selecione o testador para visualizar as contribuições ou
                  filtre por todos sem selecionar.
                </p>
              </v-col>
              <v-col>
                <v-autocomplete
                  label="Testadores"
                  v-model="desenvolvedorSelecionado"
                  :items="
                    desenvolvedores.map((desenvolvedor) => ({
                      title: desenvolvedor.usuario_git,
                      image: desenvolvedor.img_url,
                    }))
                  "
                  prepend-inner-icon="mdi-account-search"
                  variant="solo"
                  rounded
                  clearable
                  hide-no-data
                  hide-details
                  item-value="title"
                >
                  <template v-slot:item="{ props, item }">
                    <v-list-item
                      v-bind="props"
                      open-on-clear
                      :prepend-avatar="item?.raw?.image"
                      :title="item?.raw?.title"
                    ></v-list-item>
                  </template>
                  <template #selection="{ item }">
                    <v-chip size="small">
                      <v-avatar size="18" style="margin-right: 5px">
                        <img
                          :src="item.raw.image"
                          alt="User Image"
                          class="icon-user"
                        />
                      </v-avatar>
                      <span>{{ item.title }}</span>
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-tooltip location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Quando o desenvolvedor não for selecionado, são
                      considerados <strong>todos</strong> os desenvolvedores do
                      projeto.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col cols="1">
            <v-btn
              @click="filtrarContribuicoesDetalhada()"
              color="#004984"
              rounded
              outlined
              style="height: 100%; color: #f9f8f8"
              :loading="isLoading"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>

        <v-col v-if="contribuicaoDetalhada">
          <v-row>
            <v-col
              cols="6"
              v-for="(membro, index) in contribuicaoDetalhada"
              :key="index"
            >
              <h1 class="my-6" style="font-size: 18px; width: 100%">
                <v-avatar size="28" style="margin-right: 5px">
                  <img
                    :src="membro.img_url"
                    :alt="membro.responsavel"
                    class="icon-user"
                  />
                </v-avatar>
                Contribuições do Usuário: {{ membro.responsavel }}
              </h1>
              <v-row>
                <v-col>
                  <!-- <h1 class="mb-2" style="font-size: 16px; width: 100%">
                      <v-icon>mdi-source-commit</v-icon>
                      Commits
                    </h1> -->
                  <v-data-table
                    items-per-page="10"
                    no-data-text="Sem charters para listar"
                    :headers="headersCharters"
                    :items="membro.charters"
                  >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else style="height: 50vh"></v-col>
      </v-window-item>

      <v-window-item :value="2" class="my-10">
        <!-- Filtros -->
        <v-row>
          <v-col>
            <v-row align="center">
              <v-col cols="8">
                <p>
                  Selecione o testador para visualizar as contribuições ou
                  filtre por todos sem selecionar.
                </p>
              </v-col>
              <v-col>
                <v-autocomplete
                  label="Testadores"
                  v-model="desenvolvedorSelecionado"
                  :items="
                    desenvolvedores.map((desenvolvedor) => ({
                      title: desenvolvedor.usuario_git,
                      image: desenvolvedor.img_url,
                    }))
                  "
                  prepend-inner-icon="mdi-account-search"
                  variant="solo"
                  rounded
                  clearable
                  hide-no-data
                  hide-details
                  item-value="title"
                >
                  <template v-slot:item="{ props, item }">
                    <v-list-item
                      v-bind="props"
                      open-on-clear
                      :prepend-avatar="item?.raw?.image"
                      :title="item?.raw?.title"
                    ></v-list-item>
                  </template>
                  <template #selection="{ item }">
                    <v-chip size="small">
                      <v-avatar size="18" style="margin-right: 5px">
                        <img
                          :src="item.raw.image"
                          alt="User Image"
                          class="icon-user"
                        />
                      </v-avatar>
                      <span>{{ item.title }}</span>
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-tooltip location="right">
                <template #activator="{ props }">
                  <v-icon v-bind="props" size="small">
                    mdi-information-outline
                  </v-icon>
                </template>
                <template #default>
                  <div class="custom-tooltip">
                    <span
                      >Quando o desenvolvedor não for selecionado, são
                      considerados <strong>todos</strong> os desenvolvedores do
                      projeto.</span
                    >
                  </div>
                </template>
              </v-tooltip>
            </v-row>
          </v-col>

          <v-col cols="1">
            <v-btn
              @click="filtrarContribuicoesResumida()"
              color="#004984"
              rounded
              outlined
              style="height: 100%; color: #f9f8f8"
              :loading="isLoading"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-row>

        <v-col v-if="contribuicaoResumida">
          <v-row>
            <v-col
              cols="6"
              v-for="(membro, index) in contribuicaoResumida"
              :key="index"
            >
              <h1 class="my-6" style="font-size: 18px; width: 100%">
                <v-avatar size="28" style="margin-right: 5px">
                  <img
                    :src="membro.testador.imagem"
                    :alt="membro.testador.nome"
                    class="icon-user"
                  />
                </v-avatar>
                Contribuições do Usuário: {{ membro.testador.nome }}
              </h1>
              <v-row>
                <v-col>
                  <div style="color: #1d324b">
                    <p>
                      <v-icon color="#1d324b" class="mr-1"
                        >mdi-file-document-outline</v-icon
                      >
                      <strong>Total de Charters criados:</strong>
                      {{ membro.charters.totalCriados }}
                    </p>

                    <p>
                      <v-icon color="#1d324b" class="mr-1"
                        >mdi-bug-outline</v-icon
                      >
                      <strong>Total de bugs:</strong>
                    </p>
                    <p style="margin-left: 24px">
                      <v-icon color="#FF5733" class="mr-1"
                        >mdi-alert-circle-outline</v-icon
                      >
                      Identificados:
                      {{ membro.charters.totalBugs.identificados }}
                    </p>
                    <p style="margin-left: 24px">
                      <v-icon color="#3EB983" class="mr-1"
                        >mdi-check-circle-outline</v-icon
                      >
                      Confirmados: {{ membro.charters.totalBugs.confirmados }}
                    </p>

                    <p>
                      <v-icon color="#1d324b" class="mr-1"
                        >mdi-lightbulb-outline</v-icon
                      >
                      <strong>Total de melhorias:</strong>
                    </p>
                    <p style="margin-left: 24px">
                      <v-icon color="#FFC107" class="mr-1"
                        >mdi-lightbulb-on-outline</v-icon
                      >
                      Sugeridas: {{ membro.charters.totalMelhorias.sugeridas }}
                    </p>
                    <p style="margin-left: 24px">
                      <v-icon color="#3EB983" class="mr-1"
                        >mdi-check-circle-outline</v-icon
                      >
                      Confirmadas:
                      {{ membro.charters.totalMelhorias.confirmadas }}
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else style="height: 50vh"></v-col>
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    SnackBar,
    VDataTable,
  },
  data: () => ({
    tab: null,
    desenvolvedores: [],
    isLoading: false,
    idProjeto: null,
    desenvolvedorSelecionado: null,
    contribuicaoDetalhada: null,
    contribuicaoResumida: null,
    headersCharters: [
      { title: 'Nome', key: 'identificacao' },
      { title: 'Total de Bugs', key: 'totalBugs' },
      { title: 'Total de Melhorias', key: 'totalMelhorias' },
      { title: 'Bugs confirmados', key: 'bugsConfirmados' },
      { title: 'Melhorias confirmadas', key: 'melhoriasConfirmadas' },
    ],
    headersResumida: [
      { title: 'Total de Charters', key: 'totalCriados' },
      {
        title: 'Total de Bugs',
        key: 'totalBugs',
        children: [
          { title: 'Identificados', key: 'identificados' },
          { title: 'Confirmados', key: 'confirmados' },
        ],
      },
      {
        title: 'Total de Melhorias',
        key: 'totalMelhorias',
        children: [
          { title: 'Sugeridas', key: 'sugeridas' },
          { title: 'Confirmadas', key: 'confirmadas' },
        ],
      },
    ],
  }),
  created() {
    this.owner = this.$store.state.org;
    this.idProjeto = this.$route.params.id;
    this.nomeProjeto = this.$route.params.nome;
    this.obterMembrosEquipe(this.$route.params.id);
  },
  methods: {
    obterMembrosEquipe(idProjeto) {
      axios
        .get(`${API_URL}/equipes/projeto/${idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          const membrosEquipe = response.data.tb_equipe.tb_membro;
          this.desenvolvedores = membrosEquipe.map(
            (membro) => membro.tb_usuario,
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },

    filtrarContribuicoesResumida() {
      this.isLoading = true;
      this.nomeTestador = this.desenvolvedorSelecionado;

      axios
        .get(API_URL + `/api/v1/charters/visaosumarizada/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: {
            usuarioGit: this.nomeTestador,
          },
        })
        .then((response) => {
          this.contribuicaoResumida = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.messageRepo = 'Sem informações a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar as informações!',
          );
          this.isLoading = false;
        });
    },

    filtrarContribuicoesDetalhada() {
      this.isLoading = true;
      this.nomeTestador = this.desenvolvedorSelecionado;

      axios
        .get(API_URL + `/api/v1/charters/visaodetalhada/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
          params: {
            // eslint-disable-next-line
            usuario_git: this.nomeTestador,
          },
        })
        .then((response) => {
          this.contribuicaoDetalhada = response.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.messageRepo = 'Sem informações a listar.';
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            'Por algum motivo, não conseguimos buscar as informações!',
          );
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.flex-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.contribuicao-text {
  font-size: 22px;
  font-weight: bold;
}
.custom-tooltip {
  width: 250px;
}
.icon-user {
  width: 100%;
}
v-tab {
  font-size: 16px;
  padding: 0;
  text-transform: unset;
  padding-right: 16px;
  font-weight: bold;
}
</style>
